// extracted by mini-css-extract-plugin
export var dash = "spinner-module--dash--PjDPv";
export var path = "spinner-module--path--70eZT";
export var rotate = "spinner-module--rotate--mBg7B";
export var spinner = "spinner-module--spinner--k-a6g";